import React from 'react';

import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {logoutUserClearLocalStorage} from '../actions';
import store from "../store";

const HeaderDropdown = (props) => {
  const userSessionFromStore = store.getState()?.userSession;
  let username = userSessionFromStore?.username;

  return (
    <CDropdown
      inNav
      className="c-header-nav-items mx-2"
      direction="down"
    >
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <div className="loginUserName">{username}&nbsp;
        </div>
        <div className="c-avatar">
          <CImg
            src={'avatars/user.png'}
            className="c-avatar-img"
            alt={username}
          />
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem href="/#/login" onClick={logoutUserClearLocalStorage}>
          <CIcon name="cil-lock-locked" className="mfe-2"/>
          Log Out
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default HeaderDropdown;
